module.exports = "https://cdn.dove.it/_next/static/public/assets/work-with-us/dove-meeting-room.b440b5e3bf397061d4f615e8ade649a8.jpg";